import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import useQueryParams from '../../../../navigation-utils/useQueryParams';
import { closeFieldsDialog } from '../../../../reducers/funnel-flow-page/fieldsReducer';
import { closeStageDialog } from '../../../../reducers/funnel-flow-page/stageDialogReducer';
import {
  selectIsPageLoading,
  selectHasFetchingErrors,
} from '../../../../reducers/canvasPageStateReducer';
import { FunnelFlowModes } from '../../../../types/enums/FunnelFlowModes';
import { usePanels } from '../../../panels/usePanels';
import { closeFunnelSettingsDialog } from '../../funnel-map-flow/dialogs/funnel-settings-dialog/funnelSettingsReducer';
import { useSweepParams } from '../../../../navigation-utils/useSweepParams';

const usePageHelpers = () => {
  const dispatch = useDispatch();
  const { forceCloseAllPanels } = usePanels();
  const isLoading = useSelector(selectIsPageLoading);
  const hasFetchingErrors = useSelector(selectHasFetchingErrors);

  const { funnelId, funnelMapId } = useSweepParams<{ funnelId: string; funnelMapId: string }>();

  const query = useQueryParams();

  const crmOrgId = query.get('crmOrgId');
  const snapshotId = query.get('snapshotId') ?? undefined;
  const deploymentId = query.get('deploymentId') ?? undefined;
  const enableRestore = query.get('enableRestore') === 'true';

  const closeDialogs = useCallback(() => {
    dispatch(closeFieldsDialog());
    dispatch(closeStageDialog());
    dispatch(closeFunnelSettingsDialog());
    forceCloseAllPanels();
  }, [dispatch, forceCloseAllPanels]);

  const getFunnelFlowMode = () => {
    if (snapshotId && crmOrgId && deploymentId) {
      return FunnelFlowModes.DEPLOYMENT;
    }

    if (snapshotId && crmOrgId) {
      return FunnelFlowModes.NOT_DEPLOYED;
    }

    return FunnelFlowModes.EDIT;
  };

  return {
    funnelId,
    funnelMapId,
    crmOrgId,
    snapshotId,
    deploymentId,
    enableRestore,
    isLoading,
    hasFetchingErrors,

    closeDialogs,
    getFunnelFlowMode,
  };
};

export { usePageHelpers };
